/* eslint-disable max-len */
// /* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import EmptyPageLoader from '../../../components/EmptyPageLoader';
import StyledButton from '../../../components/StyledButton';

import { GET_ALL_ROLES } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import CheckIcon from '../../../svgs/CheckIcon';
import DeactivateRolesIcon from '../../../svgs/DeactivateRolesIcon';
import DropdownEditIcon from '../../../svgs/DropdownEditIcon';
import EyeIcon from '../../../svgs/EyeIcon';
import PlusIcon from '../../../svgs/PlusIcon';
import ActivateAndDeactivateBulkRoles from './ActivateAndDeactivateBulkRoles';
import ActivateRole from './ActivateRole';
import AddMember from './AddMember';
import AddMemberModal from './AddMemberModal';
import CreateRole from './CreateRole';
import DeactivateRole from './DeactivateRole';
import EditRole from './EditRole';
import RemoveMemberRole from './RemoveMember';
import Styles from './RoleAndPermission.module.scss';
import RolesCardContainer from './RolesCardContainer';
import SelectedRolesAlert from './SelectedRolesAlert';
import ViewPermission from './ViewPermission';

const RolesAndPermission = () => {
  const [customRolesRec, setCustomRolesRec] = useState([]);
  const [showCreateRoleDraw, setShowCreateRoleDraw] = useState(false);

  const [showEditRoleDraw, setShowEditRoleDraw] = useState(false);
  const [activeRoleId, setActiveRoleId] = useState(null);
  const [showAddMemeberDraw, setShowAddMemeberDraw] = useState(false);
  const [showDeactivateModal, setShowDeactivateModal] = useState(false);
  const [showActivateModal, setShowActivateModal] = useState(false);
  const [showPermissionsDrawer, setShowPermissionsDrawer] = useState(false);
  const [defaultRolesRec, setDefaultRolesRec] = useState(null);
  const [selectedDeactivatedRoles, setSelectedDeactivatedRoles] = useState([]);
  const [selectedActivatedRoles, setSelectedActivatedRoles] = useState([]);
  const [removeMemeberData, setRemoveMemeberData] = useState(null);
  const [isSelectLoader, setIsSelectLoader] = useState(null);
  const [showBulkActivateAndDeactivateModal, setShowBulkActivateAndDeactivateModal] = useState(false);
  const [selectedMemberIds, setSelectedMemberIds] = useState(null);
  const [newAddedMembers, setNewAddedMembers] = useState(null);

  const [getAllRoles, allRolesLoader, allRoles] = useCustomQuery({
    query: GET_ALL_ROLES,
    onError: () => {},
    onData: () => {},
  });

  useEffect(() => {
    getAllRoles();
  }, []);

  const getDefaultRole = (roles:any) => {
    const defaultRole = roles?.find((role:any) => role?.display_name === 'Super Admin');
    if (defaultRole) {
      const {
        id, display_name, userCount,
      } = defaultRole;

      const reformatDefaultData = {
        id,
        name: display_name,
        activeUser: userCount,
        inActiveUser: 0,
        dropdown: [
          {
            id: 1, title: 'View Permissions', value: 'View Permissions', icon: <EyeIcon width="12px" height="12px" />,
          },
          {
            id: 2, title: 'Edit', value: 'Edit', icon: <DropdownEditIcon />,
          },

        ],
      };

      setDefaultRolesRec(reformatDefaultData);
    }
  };

  const getCustomRoles = (roles:any, actionType?:string) => {
    const customRole = roles?.filter((role:any) => role?.display_name !== 'Super Admin');
    if (customRole) {
      const reformatCustomData = customRole?.map((list:any) => {
        const getDeactivatedRoles = selectedDeactivatedRoles?.find((details:any) => details?.id === list?.id);
        const getActivatedRoles = selectedActivatedRoles?.find((details:any) => details?.id === list?.id);
        return {
          id: list?.id,
          name: list?.name?.split('-').join(' '),
          display_name: list?.display_name,
          activeUser: list?.activeUserCount,
          inActiveUser: list?.inactiveUserCount,
          checked: actionType ? false : (!!getDeactivatedRoles || !!getActivatedRoles),
          status: list?.is_active ? 'Active' : 'Deactivated',
          dropdown: [
            {
              id: 1, title: 'View Permissions', value: 'View Permissions', icon: <EyeIcon width="12px" height="12px" />,
            },
            {
              id: 2, title: 'Edit', value: 'Edit', icon: <DropdownEditIcon />,
            },
            {
              id: 3,
              title: list?.is_active ? 'Deactivate Role' : 'Activate Role',
              value: list?.is_active ? 'Deactivate Role' : 'Activate Role',
              icon: list?.is_active ? <DeactivateRolesIcon /> : <CheckIcon width="12px" height="12px" color="rgba(0, 138, 0, 1)" />,
              color: list?.is_active ? 'rgba(248, 20, 20, 1)' : 'rgba(0, 138, 0, 1)',
            },

          ],
        };
      });
      setCustomRolesRec(reformatCustomData);
    }
  };

  useEffect(() => {
    if (allRoles?.getAllRoles?.roles) {
      getDefaultRole(allRoles?.getAllRoles?.roles);
      getCustomRoles(allRoles?.getAllRoles?.roles);
    }
  }, [allRoles]);

  const handleDropdownAction = (label:string, data:any) => {
    setActiveRoleId(null);
    if (label === 'Edit') {
      setShowEditRoleDraw(true);
      setActiveRoleId(data);
    }
    if (label === 'Deactivate Role') {
      setActiveRoleId(data);
      setShowDeactivateModal(true);
    }
    if (label === 'Activate Role') {
      setActiveRoleId(data);
      setShowActivateModal(true);
    }
    if (label === 'View Permissions') {
      setActiveRoleId(data);
      setShowPermissionsDrawer(true);
    }
  };

  const handleCheckCard = (data:any) => {
    const customRolesRecCheck = customRolesRec?.find((details:any) => details?.id === data?.id);

    if (customRolesRecCheck) {
      const reformatCheck = customRolesRec?.map((details:any) => (details?.id === data?.id ? { ...details, checked: !details?.checked } : details));
      setCustomRolesRec(reformatCheck);
    }
  };

  useEffect(() => {
    const customRolesIsCheckedActiveRec = customRolesRec?.filter((details:any) => details?.checked && details?.status === 'Active');
    const customRolesIsCheckedDeactivatedRec = customRolesRec?.filter((details:any) => details?.checked && details?.status !== 'Active');

    setSelectedDeactivatedRoles(customRolesIsCheckedDeactivatedRec);
    setSelectedActivatedRoles(customRolesIsCheckedActiveRec);
  }, [customRolesRec]);

  const handleAlertAction = (type:string) => {
    if (type === 'cancel') {
      setSelectedDeactivatedRoles([]);
      setSelectedActivatedRoles([]);
      getCustomRoles(allRoles?.getAllRoles?.roles, 'cancel');
      return;
    }
    if (type === 'deactivate') {
      setIsSelectLoader('activate');

      setShowBulkActivateAndDeactivateModal(true);

      return;
    }
    if (type === 'activate') {
      setIsSelectLoader('deactivate');

      setShowBulkActivateAndDeactivateModal(true);
    }
  };

  return (
    <>
      {
        allRolesLoader && !allRoles?.getAllRoles?.roles ? <EmptyPageLoader /> : (
          <div className={Styles.wrapper}>
            {
              (selectedActivatedRoles?.length || selectedDeactivatedRoles?.length) ? (
                <SelectedRolesAlert
                  // loader={modifyMutipleRolesStatusLoading}
                  submitLoaderType={isSelectLoader}
                  count={selectedDeactivatedRoles.length + selectedActivatedRoles.length}
                  isShowActivateBtn={!!selectedDeactivatedRoles.length}
                  isShowDeactivateBtn={!!selectedActivatedRoles.length}
                  onAction={
                    handleAlertAction
                  }
                />
              ) : ''
            }

            <div className={Styles.wrapper__createBtnContainer}>
              <StyledButton name="Create Custom Roles" padding="10px 16px" backgroundColor="black" fontSize="14px" color="white" border="none" borderRadius="4px" icon={<PlusIcon />} onClick={() => setShowCreateRoleDraw(true)} />
            </div>
            <div>
              <RolesCardContainer handleCheckCard={handleCheckCard} customData={customRolesRec} defaultData={defaultRolesRec} handleDropdown={handleDropdownAction} />
            </div>
            {
              showCreateRoleDraw && <CreateRole onClose={() => setShowCreateRoleDraw(false)} refetch={getAllRoles} />
            }
            {
              showEditRoleDraw && activeRoleId && (
              <EditRole
                onClose={() => setShowEditRoleDraw(false)}
                handleAddMemeber={() => {
                  setShowAddMemeberDraw(true);
                  setShowEditRoleDraw(false);
                }}
                payload={activeRoleId}
                refetch={getAllRoles}
                handleRemove={(data:any) => {
                  setRemoveMemeberData(data);
                  setShowEditRoleDraw(false);
                }}
              />
              )
            }
            {
              showAddMemeberDraw && activeRoleId && (
              <AddMember
                onClose={() => {
                  setShowEditRoleDraw(true);
                  setShowAddMemeberDraw(false);
                }}
                activeRoleId={activeRoleId}
                selectedNewAddedMember={(data:any) => setNewAddedMembers(data)}
                selectedMembers={(data:any) => {
                  setSelectedMemberIds(data);
                  setShowAddMemeberDraw(false);
                }}
              />
              )
            }
            {
              showDeactivateModal && activeRoleId && <DeactivateRole payload={activeRoleId} onClose={() => setShowDeactivateModal(false)} refetch={getAllRoles} />
            }
            {
              showActivateModal && activeRoleId && <ActivateRole payload={activeRoleId} onClose={() => setShowActivateModal(false)} refetch={getAllRoles} />
            }

            {
              removeMemeberData && (
              <RemoveMemberRole
                refetch={getAllRoles}
                payload={removeMemeberData}
                activeRoleId={activeRoleId}
                onClose={() => {
                  setRemoveMemeberData(null);
                  setShowEditRoleDraw(true);
                }}
              />
              )
            }

            {
              selectedMemberIds && activeRoleId && newAddedMembers && (
              <AddMemberModal
                newAddedMembers={newAddedMembers}
                selectedMemberIds={selectedMemberIds}
                activeRoleId={activeRoleId}
                refetch={getAllRoles}
                onClose={() => {
                  setSelectedMemberIds(null);
                  // setShowAddMemeberDraw(true);
                  setShowEditRoleDraw(true);
                }}
              />
              )
            }

            {
              showPermissionsDrawer && activeRoleId && <ViewPermission payload={activeRoleId} onClose={() => setShowPermissionsDrawer(false)} />
            }
            {
              showBulkActivateAndDeactivateModal && isSelectLoader && <ActivateAndDeactivateBulkRoles setSelectedDeactivatedRoles={(data:any) => setSelectedDeactivatedRoles(data)} setSelectedActivatedRoles={(data:any) => setSelectedActivatedRoles(data)} onClose={() => setShowBulkActivateAndDeactivateModal(false)} selectedDeactivatedRoles={selectedDeactivatedRoles} selectedActivatedRoles={selectedActivatedRoles} refetch={getAllRoles} isSelectLoader={isSelectLoader} />
            }

          </div>
        )
      }

    </>
  );
};

export default RolesAndPermission;
